var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirporticon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66382 1.33203V2.66479",
    stroke: "white",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32928 1.33203V2.66479",
    stroke: "white",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6621 5.33008C10.8388 5.33008 11.0083 5.40029 11.1333 5.52526C11.2582 5.65023 11.3285 5.81972 11.3285 5.99646V11.3275C11.3285 12.0344 11.0476 12.7124 10.5477 13.2123C10.0479 13.7122 9.36988 13.993 8.66294 13.993H4.66466C3.95772 13.993 3.27974 13.7122 2.77986 13.2123C2.27998 12.7124 1.99915 12.0344 1.99915 11.3275V5.99646C1.99915 5.81972 2.06935 5.65023 2.19432 5.52526C2.31929 5.40029 2.48879 5.33008 2.66552 5.33008H11.9948C12.7018 5.33008 13.3798 5.61091 13.8796 6.11079C14.3795 6.61067 14.6603 7.28866 14.6603 7.99559C14.6603 8.70253 14.3795 9.38052 13.8796 9.8804C13.3798 10.3803 12.7018 10.6611 11.9948 10.6611H11.3285",
    stroke: "white",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99829 1.33203V2.66479",
    stroke: "white",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirporticon);
export default __webpack_public_path__ + "static/media/airporticon.dbd646ceb2e07ab0c121fd1dccb16c40.svg";
export { ForwardRef as ReactComponent };